import { render, staticRenderFns } from "./myChat.vue?vue&type=template&id=4086bdfe&scoped=true&"
import script from "./myChat.vue?vue&type=script&lang=js&"
export * from "./myChat.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("../../../assets/css/leftnavChat.css?vue&type=style&index=0&id=4086bdfe&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4086bdfe",
  "44706824"
  
)

export default component.exports